<pt-breadcrumbs
  class="border-b border-solid border-slate-300 bg-white"
  current="BigQuery Update Jobs"
  [breadcrumbs]="breadcrumbs"
/>

<div class="mx-auto flex flex-col gap-4 p-4">
  <h1 class="!m-0 text-xl !font-bold">BigQuery Upload Jobs</h1>

  <pr-information-box>
    This page provides an overview of BigQuery Upload Jobs from the past 10
    minutes. Including statistics for bucket monitoring.
  </pr-information-box>

  <pr-big-query-upload-toolbar [recentDuration]="recentDuration" />

  <div class="rounded-md bg-white shadow-md">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (tab of tabs; track tab.label) {
        <a
          #rla="routerLinkActive"
          mat-tab-link
          routerLinkActive
          [routerLink]="tab.path"
          [active]="rla.isActive"
        >
          {{ tab.label }}
        </a>
      }
    </nav>
  </div>

  <mat-tab-nav-panel #tabPanel>
    <router-outlet />
  </mat-tab-nav-panel>
</div>
